<template>
  <div class="vs-loading-style">
    <vs-dialog
      :visible.sync="loadingDataVisible"
      width="0%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :destroy-on-close="true"
      :transition="false"
      center>
      <div>
        <div class="loader">
        </div>
      </div>
      <div class="loadingText">{{ loadingText ? loadingText : 'Loading' }}</div>
      <span slot="footer" class="dialog-footer"></span>
    </vs-dialog>
  </div>
</template>

<script>
export default {
  name: "animation",
  props: ["loadingDataVisible", "loadingText"],
}
</script>

<style scoped>

.loader {
  width: 4em;
  height: 4em;
  font-size: 25px;
  box-sizing: border-box;
  border-top: 1em solid hotpink;
  border-radius: 50%;
  position: relative;
  animation: rotating 2s ease-in-out infinite;
  --direction: 1;
}

.loader::before,
.loader::after {
  content: '';
  position: absolute;
  width: inherit;
  height: inherit;
  border-radius: 50%;
  box-sizing: border-box;
  top: -1em;
}

.loader::before {
  border-top: 1em solid dodgerblue;
  transform: rotate(120deg);
}

.loader::after {
  border-top: 1em solid gold;
  transform: rotate(240deg);
}

.loader span {
  position: absolute;
  color: white;
  width: inherit;
  height: inherit;
  text-align: center;
  line-height: 6em;
  font-family: sans-serif;
  font-size: 16px;
  animation: rotating 2s linear infinite;
  --direction: -1;
}

@keyframes rotating {
  50% {
    transform: rotate(calc(180deg * var(--direction)));
  }

  100% {
    transform: rotate(calc(360deg * var(--direction)));
  }
}

/*设置动画的位置*/
/deep/ .el-dialog__wrapper {
  position: fixed;
  /*top: 15%;*/
  /*right: 10%;*/
  /*bottom: 0;*/
  /*left: 0;*/
  margin: 0;
  /*隐藏加载页面的滚动条*/
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loadingText {
  color: white;
  float: left;
  height: 30px;
  width: 100px;
  text-align: center;
  line-height: 30px;
  font-size: 20px
}

.loadingText::after {
  content: '';
  width: 3px;
  height: 3px;
  display: inline-block;
  animation-name: loadingText;
  animation-duration: 1s;
  animation-iteration-count: infinite;
}

@keyframes loadingText {
  from {
    box-shadow: none;
  }
  30% {
    box-shadow: 3px 0 0 currentColor;
  }
  60% {
    box-shadow: 3px 0 0 currentColor, 9px 0 0 currentColor;
  }
  90% {
    box-shadow: 3px 0 0 currentColor, 9px 0 0 currentColor, 15px 0 0 currentColor;
  }

}

/deep/ .v-modal {
  z-index: 99 !important;
}

/deep/ .el-dialog--center {
  margin: 0 !important;
}

/deep/ .el-dialog__wrapper.dialog-fade-leave-active,
.el-dialog__wrapper.dialog-fade-enter-active {
  animation: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/loading/animation.vue